export const QUERY_KEYS = {
  SUBSCRIPTIONS_LIST: "SUBSCRIPTIONS_LIST",
};

export const SUBSCRIPTION_STATUS = { past_due: "past_due" };
